import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from 'react-tooltip-lite';

import styles from './AiShortcut.module.css';

import { Typography } from '@/shared/components/atoms';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Close from '~/images/shared/Close.svg';
import TransparentAiIcon from '~/images/shared/TransparentAiIcon.svg';
import AI from '~/images/sideMenu/ai-icon.svg';

// TODO: feature/ai Translate

function AiShortcut() {
  const { t } = useTranslation('ai');
  const [store] = useStore((s) => s);
  const { collapseState } = useAuth();

  const isRealAsset = store?.asset?.id !== -1;

  // ===============================
  // show the tooltip to user only for one type the user select a real asset
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const selectRealAssetBefore = localStorage.getItem('selectRealAssetBefore');

    if (isRealAsset && selectRealAssetBefore !== '1') {
      setShowTooltip(true);
      localStorage.setItem('selectRealAssetBefore', '1');
    }
  }, [isRealAsset]);
  // ===============================

  if (showTooltip) {
    return (
      <Tooltip
        direction='right'
        tipContentClassName={styles['custom-wrapper']}
        className={styles['custom-tooltip']}
        arrow={false} // <--- Turn OFF the default arrow
        isOpen={true}
        padding={0}
        distance={12}
        content={
          <div className='relative flex h-[64px] w-[280px] items-center justify-center text-white'>
            {/* Custom Arrow */}
            <div
              className='absolute -left-2 top-1/2 h-16 w-16 -translate-y-1/2 rotate-45  rtl:-right-2 '
              style={{
                background: 'linear-gradient(135deg, #3432C7 0%, #B632C7 100%)',
              }}
            ></div>

            {/* Tooltip Content */}
            <div
              className='absolute h-full w-full rounded-xl '
              style={{
                background: 'linear-gradient(135deg, #3432C7 0%, #B632C7 100%)',
              }}
            >
              <div className='flex items-center justify-between'>
                <Typography
                  component='p'
                  variant='subtitle'
                  className='font-bold!'
                >
                  {t('got-question')}{' '}
                </Typography>
                <button onClick={() => setShowTooltip(false)}>
                  <Close width={12} height={12} />
                </button>
              </div>
              <Typography component='p'>{t('tap-to-ask-ai')} </Typography>
            </div>
          </div>
        }
      >
        {!collapseState ? (
          <AI width={32} height={32} />
        ) : (
          <TransparentAiIcon width={26} height={26} />
        )}
      </Tooltip>
    );
  }

  return (
    <>
      {!collapseState ? (
        <AI width={32} height={32} />
      ) : (
        <TransparentAiIcon width={26} height={26} />
      )}
    </>
  );
}

export default AiShortcut;
